import { breakpoints, colors, getTypography, pxToRem } from '@vfit/shared/themes';
import styled, { css } from 'styled-components';
import { ITag, TagType, TagVariant } from './tag.models';

/**
 * TEXT COLORS CSS DEFINITION
 */
const black_text = css`
  color: ${colors.$0d0d0d};
`;
const white_text = css`
  color: ${colors.$ffffff};
`;
const grey_text = css`
  color: ${colors.$f2f2f2};
`;
const opaque_text = css`
  color: ${colors.$ffffff_80};
`;

/**
 * BACKGROUND COLORS CSS DEFINITION
 */

const black = css`
  background-color: ${colors.$0d0d0d};
`;
const white = css`
  background-color: ${colors.$ffffff};
`;
const grey = css`
  background-color: ${colors.$f2f2f2};
`;
const opaque = css`
  background-color: ${colors.$ffffff_80};
`;
const transparent = css`
  background-color: ${colors.$transparent};
`;

/**
 * BORDER COLORS CSS DEFINITION
 */
const white_border = css`
  border: 1px solid ${colors.$ffffff};
`;
const grey_border = css`
  border: 1px solid ${colors.$f2f2f2};
`;
const opaque_border = css`
  border: 1px solid ${colors.$ffffff_80};
`;

const getBackgroundColor = (
  variant?: TagVariant,
  type?: TagType,
  isSelected?: boolean,
  isHover?: boolean
) => {
  if (isHover && !isSelected) {
    if (!type || type === 'default') {
      switch (variant) {
        case 'grey':
          return white;
        case 'opaque':
          return white;
        default:
          return black;
      }
    }
    return white;
  }
  if (!type || type === 'default' || isSelected) {
    switch (variant) {
      case 'grey':
        return grey;
      case 'opaque':
        return opaque;
      default:
        return white;
    }
  }
  return transparent;
};

const getTextColor = (
  variant?: TagVariant,
  type?: TagType,
  isSelected?: boolean,
  isHover?: boolean
) => {
  if (isHover && !isSelected) {
    if (!type || type === 'default') {
      if (variant === 'white') {
        return white_text;
      }
    }
    switch (variant) {
      case 'grey':
        return white_text;
      case 'opaque':
        return white_text;
      default:
        return black_text;
    }
  } else {
    if (!type || type === 'default' || isSelected) {
      if (variant === 'white') {
        return black_text;
      }
    }
    switch (variant) {
      case 'grey':
        return grey_text;
      case 'opaque':
        return opaque_text;
      default:
        return white_text;
    }
  }
};

const getBorderColor = (variant?: TagVariant) => {
  switch (variant) {
    case 'grey':
      return grey_border;
    case 'opaque':
      return opaque_border;
    default:
      return white_border;
  }
};

export const Li = styled.li<ITag>`
  ${getTypography('tag.regular')}
  border-radius: ${pxToRem(20)};
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: ${pxToRem(4, 16)};
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ variant, type, isSelected, isHover }) =>
    getBackgroundColor(variant, type, isSelected, isHover)}
  ${({ variant }) => getBorderColor(variant)}
  ${({ variant, type, isSelected, isHover }) => getTextColor(variant, type, isSelected, isHover)}

  &:hover {
    cursor: pointer;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: ${pxToRem(4, 16)};
  }
`;

